// @flow

import { observer } from "mobx-react";
import React from "react";
import ResizeObserver from 'react-resize-observer';

import TimelineItem from "app/models/TimelineItem";
import Video from "app/models/Video";

import TimelinePositioner from "app/components/TimelinePositioner/TimelinePositioner";
import TimelineItemComponent from "app/components/TimelineItem/TimelineItem";

import "./TimelineItems.scss";

const itemsCountThreshold = 5;

type Props = {
    video: Video,
    items: TimelineItem[],
    selectedItem?: ?TimelineItem,
    onSelect?: Function,
    onDeselect?: Function,
    onMouseEnter?: Function,
    onDrag?: Function,
    wizard?: boolean,
    scale: number,
    isMobile: boolean,
    freezeScale?: boolean
};

type State = {
    containerWidth: number
};

const STEP_DISTANCE_PERCENTAGE = 5;

@observer
export default class TimelineItems extends React.Component<Props, State> {
    viewportElement: ?HTMLElement;
    selectedItemElement: ?HTMLElement;

    constructor() {
        super();
        this.state = {
            containerWidth: 900
        };
    }

    render() {
        const classes = [
            "TimelineItems",
            "TimelineItems--" +
                (this.props.items.length > itemsCountThreshold
                    ? "big"
                    : "small")
        ];

        return (
            <div className={classes.join(" ")}>
                <ResizeObserver
                    onResize={(rect) => {
                        this.setState({containerWidth: rect.width});
                    }} />
                <div
                    className="TimelineItems__viewport"
                    ref={viewport => (this.viewportElement = viewport)}
                >
                    {this.renderContent()}
                </div>
            </div>
        );
    }

    renderContent() {
        let downStepsCounter = 0;

        let downSteps: number[] = this.props.items.map((item, index) => {
            if (index > 0) {
                const lastItem = this.props.items[index - 1];
                const distancePercentage =
                    ((item.start_time - lastItem.start_time) * 100) /
                    this.props.video.duration;

                if (distancePercentage <= STEP_DISTANCE_PERCENTAGE) {
                    downStepsCounter++;
                } else {
                    downStepsCounter = 0;
                }
            }

            return downStepsCounter;
        });

        let items = this.props.items;

        const itemComponents = items.map((item: TimelineItem, index) => {
            return this.renderPositioner(item, downSteps[index]);
        });

        return <div className="TimelineItems__content">{itemComponents}</div>;
    }

    scrollToHiddenItem() {
        const itemEl = this.selectedItemElement;
        const viewportEl = this.viewportElement;

        if (this.props.state === -1 || !itemEl || !viewportEl) return;

        const desiredLeft = itemEl.offsetLeft;
        const overflowLeft = viewportEl.scrollLeft + viewportEl.offsetLeft;

        const desiredRight = desiredLeft + itemEl.offsetWidth;
        const overflowRight = overflowLeft + viewportEl.offsetWidth;

        if (desiredRight > overflowRight) {
            viewportEl.scrollLeft += desiredRight - overflowRight;
        } else if (desiredLeft < overflowLeft) {
            viewportEl.scrollLeft += desiredLeft - overflowLeft;
        }
    }

    componentDidMount() {
        this.scrollToHiddenItem();
    }

    componentDidUpdate({ selectedItem }: any) {
        if (this.props.selectedItem !== selectedItem) {
            this.scrollToHiddenItem();
        }
    }

    renderPositioner(item: TimelineItem, downSteps: number) {
        const selectedItem: any = this.props.selectedItem;
        const selected = selectedItem === item;
        return (
            <TimelinePositioner
                key={item.key}
                video={this.props.video}
                item={item}
                selectedItem={selectedItem}
                onDrag={this.props.onDrag}
                wizard={this.props.wizard}
                scale={this.props.scale}
                isMobile={this.props.isMobile}
                downSteps={downSteps}
                containerWidth={this.state.containerWidth}
            >
                <div
                    ref={el =>
                        selected ? (this.selectedItemElement = el) : null
                    }
                >
                    
                    <TimelineItemComponent
                        key={item.key}
                        authorImage={this.props.video.author_image || undefined}
                        item={item}
                        selected={selected}
                        onSelect={this.props.onSelect}
                        onDeselect={this.props.onDeselect}
                        onMouseEnter={this.props.onMouseEnter}
                        scale={this.props.scale}
                        wizard={this.props.wizard}
                        freezeScale={this.props.freezeScale}
                    />
                </div>
            </TimelinePositioner>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/TimelineItems/TimelineItems.js